/**
 * Created by emilgrabowiec on 17.03.2016.
 */
require('../../search/_submit');

$(() => {
  $('.tagsinput').tagsInput({
    interactive: false,
    delimiter: '|'
  });

  $('.select-hymnal').select2({
    placeholder: 'Hymnals / Resources'
  });

  $('.select-licenseType').select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });

  $('#bulk-action').select2({
    placeholder: 'Select Action',
    minimumResultsForSearch: Infinity,
    width: '100%'
  });

  if ($('.select-licenseType').length) {
    $('.duplicate').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('.duplicate').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity
    });
  }

  $('.duplicate').on('select2:close', function (e) {
    const idReprint = $('.select-licenseType').find('option:selected').val();
    const data = $(this).select2('data')[0];
    $('.tagsinput').addTag(`${data.id}_${idReprint}`, data.text, { unique: true });
  });


  $('#duplicateModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);
    const id = btn.data('registration');

    $('#submit-duplicate').data('id', id);
  });

  $('#duplicateForm').submit((e) => {
    e.preventDefault();
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const id = $(this).find('option:selected').val();

    $('.time-report').select2('val', '');
    $('.time-report').select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      $('.time-report option').remove();

      $.each(data.weeks, (i, item) => {
        $('.time-report').append($('<option>', {
          value: i,
          text: item
        }));
      });

      $('.time-report').select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });
    }, 'json');
  });

  $('.text-green').popover({
    placement: 'bottom',
    content: 'You will not be reminded to report this week',
    trigger: 'hover'
  });

  $('#submit-duplicate').click(function (e) {
    const btnRfc = $(this);
    const id = $(this).data('id');
    const weekSpans = $('#duplicateForm').find('span.selected-report-date');
    const weeks = new Array();

    weekSpans.each(function (index) {
      weeks.push($(this).data('id'));
    });

    if (weeks.length > 0) {
      btnRfc.button('loading');

      $.post(duplicateReportUrl, {
        id,
        weeks
      }, (data, b) => {
        btnRfc.button('reset');

        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          location.reload();
        }
      });
    } else {
      toastr.error('Please select weeks to report for.', 'Error');
    }

    e.preventDefault();
  });

  $('#NumServiceModal').modal('show');

  $(document).on('hide.bs.modal', '#NumServiceModal', function () {
    const value = $('#num_services').val();
    $(this).css('display', 'none');
    $(this).prev('img').css('display', 'block');
    $.post(changeServiceUrl, {
      value
    }, function (data, b) {
      $(this).css('display', 'block');
      $(this).prev('img').css('display', 'none');
      if (data.isError == false) {
        $('#NumServiceModal').modal('hide');
        toastr.success('Service has been successfully updated', 'Success');
      }
    });
  });

  $('#NumServiceModal #saveOS').click(function () {
    const value = $('#num_services').val();
    $(this).css('display', 'none');
    $(this).prev('img').css('display', 'block');
    $.post(changeServiceUrl, {
      value
    }, function (data, b) {
      $(this).css('display', 'block');
      $(this).prev('img').css('display', 'none');

      $('#NumServiceModal').modal('hide');
      toastr.success('Service has been successfully updated', 'Success');
    });
  });

  $('button[name="submit-bulk"]').click(function () {
    const registrations = new Array();
    const btnRfc = $(this);

    $('.main-container').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        registrations.push($(this).val());
      }
    });

    btnRfc.button('loading');

    $.post(bulkActionUrl, {
      bulkAction: $('#bulk-action').val(),
      data: JSON.stringify(registrations)
    }, (data, b) => {
      btnRfc.button('reset');

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        for (let i = 0; i < data.updatedRegs.length; i++) {
          const elem = $(`#reg-${data.updatedRegs[i]}`).parent().parent().parent()
              .find('.reported-info');

          switch (data.action) {
            case 'mark':
              elem.removeClass('text-red');

              var checks = elem.find('.fa');

              if (checks.length == 0) {
                elem.append(' <i class="fa fa-check" aria-hidden="true"></i>');
              }

              break;
            case 'unmark':
              if (elem.text().match('0 Reported')) {
                elem.addClass('text-red');
              }

              elem.find('.fa').remove();
              break;
          }
        }

        $('.reported-info').popover('destroy');

        $('.text-green').popover({
          placement: 'bottom',
          content: 'You will not be notified about this week anymore.',
          trigger: 'hover'
        });

        /* uncheck checkboxes */
        $('.main-container').find('input[type="checkbox"]').each(function () {
          if ($(this).is(':checked')) {
            $(this).attr('checked', false);
          }
        });

        toastr.success('Report succesfully updated.', 'Success');
      }
    });
  });

  $('a#print-year-report-btn').click(function (e) {
    e.preventDefault();
    const organizationId = $(this).data('id');

    $.get(`${urlYearReport}/${organizationId}`, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        window.location = '/my-account?tab=downloads';
      }
    }, 'json');
  });
});
